module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.33838/images/ao-hero-img.webp"